import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('advbr_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Endpoints
export const authApi = {
  register: (data) => api.post('/auth/register', data).then(r => r.data),
  login: (data) => api.post('/auth/login', data).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
};

export const firmsApi = {
  list: (params = {}) => api.get('/firms', { params }).then(r => r.data),
  get: (slug) => api.get(`/firms/${slug}`).then(r => r.data),
  update: (id, data) => api.put(`/firms/${id}`, data).then(r => r.data),
  addArticle: (id, data) => api.post(`/firms/${id}/articles`, data, { timeout: 60000 }).then(r => r.data),
  addPost: (id, data) => api.post(`/firms/${id}/posts`, data).then(r => r.data),
};

export const reviewsApi = {
  list: (firmId) => api.get(`/firms/${firmId}/reviews`).then(r => r.data),
  create: (firmId, data) => api.post(`/firms/${firmId}/reviews`, data).then(r => r.data),
};

export const aiApi = {
  match: (problem, opts = {}) => api.post('/ai/match', { problem, ...opts }, { timeout: 90000 }).then(r => r.data),
  generateArticle: (topic, area, tone) => api.post('/ai/generate-article', { topic, area, tone }, { timeout: 90000 }).then(r => r.data),
};

export const articlesApi = {
  list: (params = {}) => api.get('/articles', { params }).then(r => r.data),
  get: (firmSlug, articleId) => api.get(`/articles/${firmSlug}/${articleId}`).then(r => r.data),
};

export const metaApi = {
  cities: () => api.get('/cities').then(r => r.data),
  categories: () => api.get('/categories').then(r => r.data),
  stats: () => api.get('/stats').then(r => r.data),
};

export const saasApi = {
  registerBasic: (data) => api.post('/auth/register-basic', data).then(r => r.data),
  plans: () => api.get('/plans').then(r => r.data),
  claim: (firmId, data) => api.post(`/firms/${firmId}/claim`, data).then(r => r.data),
  subscription: () => api.get('/billing/subscription').then(r => r.data),
  checkout: (planId) => api.post('/billing/checkout', { planId }).then(r => r.data),
  cancelSubscription: () => api.post('/billing/cancel').then(r => r.data),
  convStart: (firmSlug) => api.post('/conversations', { firmSlug }).then(r => r.data),
  convMessage: (id, text) => api.post(`/conversations/${id}/messages`, { text }, { timeout: 90000 }).then(r => r.data),
  convConsent: (id, authorized) => api.post(`/conversations/${id}/consent`, { authorized }).then(r => r.data),
  inbox: () => api.get('/inbox').then(r => r.data),
  crmContacts: () => api.get('/crm/contacts').then(r => r.data),
  crmUpdate: (id, data) => api.patch(`/crm/contacts/${id}`, data).then(r => r.data),
  appointments: () => api.get('/appointments').then(r => r.data),
  createAppointment: (data) => api.post('/appointments', data).then(r => r.data),
  cancelAppointment: (id) => api.post(`/appointments/${id}/cancel`).then(r => r.data),
};

export const adminApi = {
  overview: () => api.get('/admin/overview').then(r => r.data),
  claims: () => api.get('/admin/claims').then(r => r.data),
  approveClaim: (id) => api.post(`/admin/claims/${id}/approve`).then(r => r.data),
  rejectClaim: (id) => api.post(`/admin/claims/${id}/reject`).then(r => r.data),
  subscriptions: () => api.get('/admin/subscriptions').then(r => r.data),
  consents: () => api.get('/admin/consents').then(r => r.data),
  events: () => api.get('/admin/events').then(r => r.data),
  firms: (q) => api.get('/admin/firms', { params: q ? { q } : {} }).then(r => r.data),
  suspend: (id) => api.post(`/admin/firms/${id}/suspend`).then(r => r.data),
  sponsor: (id, sponsored) => api.post(`/admin/firms/${id}/sponsor`, { sponsored }).then(r => r.data),
};
